// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ResetPasswordForShopRequestModel from '../../model/reset-password-for-shop-request-model';
import ResetPasswordForShopRequestDTO from '../dto/reset-password-for-shop-request-dto';
import dtoSchema from '../schemas/reset-password-for-shop-request-schema';

export default abstract class ResetPasswordForShopRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ResetPasswordForShopRequestDTO>) {
    super();
    if (data) {
      this.username = data.username ?? undefined;
    }
  }
  /**
  */
  username?: string;

  static toModel(dto: DeepPartial<ResetPasswordForShopRequestDTO>): ResetPasswordForShopRequestModel;
  static toModel(dto: DeepPartial<ResetPasswordForShopRequestDTO> | undefined | null): ResetPasswordForShopRequestModel | undefined;
  static toModel(dto: DeepPartial<ResetPasswordForShopRequestDTO> | undefined | null): ResetPasswordForShopRequestModel | undefined {
    return dto ? new ResetPasswordForShopRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ResetPasswordForShopRequestModel> | ResetPasswordForShopRequestModel): ResetPasswordForShopRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      username: unwrapped.username,
    } as ResetPasswordForShopRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ResetPasswordForShopRequestModel, can not map to ResetPasswordForShopRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
